import React from "react"
import "tachyons/css/tachyons.css"
import "@fortawesome/fontawesome-svg-core/styles.css"
import Helmet from "react-helmet"
import {graphql, StaticQuery} from "gatsby"
import TopNav from "./TopNav/topnav"
import {Footer} from "./Footer/Footer"
import ProtectedPage from './Protected/protected'

const Layout = ({children}) => (
    <StaticQuery
        query={graphql`
    query LayoutQuery {
           site {
             siteMetadata {
               title
             }
           }
         }
       `}
        render={data => (
            <>
              <Helmet titleTemplate={`%s | ${data.site.siteMetadata.title}`}
                      defaultTitle={data.site.siteMetadata.title}/>
              <div id="site-wrapper">

                <div id="content-and-header">
                  <TopNav/>
                    <div id="site-content">
                      <div id="main">
                        {children}
                      </div>
                    </div>
                </div>
              </div>
            </>
        )}
    />
)

export default Layout
